import { resolveId } from '@wix/communities-blog-client-common';

export function getChannel(entity: { type: string } & Record<string, unknown>) {
  return `${entity.type}-${resolveId(entity as any)}`;
}
